import { SignInWithMessage } from './SignInWithMessage';
export class SiwcMessage extends SignInWithMessage {
    isMessageSigned(message, signature, address) {
        // For Cardano, signature verification is done on the backend
        // This is because Cardano uses Ed25519 signatures which require
        // the public key (provided in the 'key' field) for verification
        // We'll pass this validation and let the backend handle it
        return true;
    }
}
